/**
 * Morgenlage (h-cockpit-daily-dashboard-redesign) — the Cockpit successor at
 * /apps/morgenlage (old /apps/cockpit redirects here; the `apps.cockpit` flag
 * id is unchanged — it is baked into backend migration 037).
 *
 * This slice hosts the design-system Morgenlage CONCEPT view: verdict-first
 * daily briefing with Beispieldaten, self-labelled as Konzeptentwurf in its
 * footer. It replaces the #2954 Cockpit section shell, which was retired with
 * its hooks and e2e specs (git history has them) — when sections come back
 * with real twin data they will be wired against the twin API generic reads,
 * not the old shell.
 */
import { Morgenlage, PageLoadOverlay } from '@hofsync/design-system';

import { usePageLoadTelemetry } from '../../../hooks/usePageLoadTelemetry';

export default function MorgenlagePage() {
  const pageLoadOverlay = usePageLoadTelemetry({
    page: 'morgenlage',
    view: 'morgenlage:konzept',
    isLoading: false,
  });

  return (
    <div className="morgenlage-page">
      <PageLoadOverlay
        visible={pageLoadOverlay.showOverlay}
        elapsedSeconds={pageLoadOverlay.elapsedSeconds}
      />
      <Morgenlage />
    </div>
  );
}
